export const SET_PENDING = "state/portal-users/SET_PENDING";
export const SET_TOUCHED = "state/portal-users/SET_TOUCHED";
export const SET_PORTAL_USERS = "state/portal-users/SET_PORTAL_USERS";
export const FORGET_PORTAL_USERS = "state/portal-users/FORGET_PORTAL_USERS";
